import Toast from './Toast';

export default Toast;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toast/index.tsx